'use strict';

angular.module('directives.confirmClickDirective', ['mgcrea.ngStrap'])

.directive('confirmClick', ['$modal', '$rootScope', function ($modal, $rootScope) {
    return {
        link: function (scope, element, attr) {
            element.bind('click', function (event) {
                var clickAction = attr.confirmClick;

                var confirmCondition = false;
                if(angular.isDefined(attr.confirmCondition)) {
                    confirmCondition = scope.$eval(attr.confirmCondition);
                }

                if (confirmCondition) {
                    var modalScope = $rootScope.$new();
                    modalScope.title = attr.confirmTitle;
                    modalScope.content = attr.confirmContent;

                    var confirmModal = $modal({
                        scope: modalScope,
                        show: true,
                        template: '/app/shared/components/directives/confirmClick.tpl.html',
                        placement: 'center'
                    });

                    modalScope.hideModal = function () {
                        confirmModal.$promise.then(confirmModal.hide);
                    }

                    modalScope.ok = function () {
                        modalScope.hideModal();
                        scope.$eval(clickAction);
                    }
                } else {
                    scope.$eval(clickAction);
                }
            });
        }
    };
}]);
